<template>
    <div>
        <div class="relative">
            <div class="relative"  v-for="(item, index) in result" >
                <template class="m-b-15" v-for="x in item">
                    <div 
                        class="flex" 
                        >
                        <!-- @click="toggle(index)" -->
                        <h1 
                            class="title is-4 is-white" 
                            :class="{'m-b-15':true}" 
                            v-if="x.field.label === 'Category'">
                            {{x.value}}
                        </h1>
                        <!-- <icon v-if="x.field.label === 'Category'" :name="expand && current === index ? 'minus': 'plus'" class=" is-white" scale="1.2"></icon> -->
                    </div>
                    <div :class="{'toggle': !expand}" >
                        <h2 class="title is-5 is-white" v-if="x.field.label === 'Subcategory'">
                            <router-link :to="`/solutions/${x.value}`">
                               <img class="img" src="/fstatic/spinner.svg"> {{x.value}}
                            </router-link>
                        </h2>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    created() {
        console.log(this.solutions);
        let array = this.solutions.slice();
        array.filter( (e) => e.field.label === 'Category' );
        // know the indexes of `category`
        let indeces = [];
        array.map( (e) => e.field.label === 'Category' ? indeces.push(array.indexOf(e)) : null)
        // cut array from one index till next index
        for (let i = 0; i < indeces.length; i++) {
            this.result.push(array.slice(indeces[i], indeces[i+1]) )
        }
        console.log(this.result);
    },
    methods: {
        toggle(number) {
            this.expand = true;
            this.current = number;
        }
    },
    data() {
        return {
            result: [],
            expand: false,
            current: null,
        }
    },
    props: {
        solutions: {
            type: Array,
            required: true,
        }
    }
}
</script>

<style lang="scss" scoped>
    .flex {
        // align-items: center;
    }
    .toggle {
        overflow: hidden;
        // animation: toggle 1.5s 1;
    }
    @keyframes toggle {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
    h2 {
        margin-left: 15px;
        margin-bottom: 10px;
    }
    svg {
        // right: 0px;
        margin-left: auto;
        position: relative;
        bottom: 6px;
        // top: 3px;
    }
    .flex {
        align-items: center;
    }
    img {
        height: 15px;
    }
</style>



// WEBPACK FOOTER //
// solutionsDropdown.vue?3d50aab6